module.exports = __webpack_public_path__ + "media/icons/widget-section-e-67be5cde.png";